<template>
  <Layout :title="crud ? '템플릿 ' + crud : ''" :leftButtonName="$t('템플릿 메뉴')">
    <!-- 수정 추가 화면 -->
    <template v-if="tmpl && crud && !tmpl.pwdExist">
      <template slot="previous">
        <a class="btn btn-icon btn-active-secondary rounded-pill" @click="$go('/tmpl');">
          <i class="bi bi-chevron-left fs-2hx"></i>
        </a>
      </template>
      <template slot="toolbar">
        <!-- editorTestMode<b-form-checkbox class="me-9" switch v-model="editorTestMode" /> -->
        <a v-if="device == 'WEB'" class="btn btn-secondary" @click="goBackToList(listParams.mode, listParams.dirId)" v-text="$t('돌아가기')" />
      </template>
      <template slot="content">
        <div v-if="editorStep" style="position:relative">
          <b-embed v-if="editorStep" :class="{ full: editorFull }" class="card embed" :src="`${signerBase}${tmpl.tmplId}${isMyTmpl ? '?disable=valueonly' : ''}`" />
          <div class="editor-header-left gap-3" :class="{ 'fullscreen': editorFull }">
            <a v-if="editorFull == true" class="icon" @click="editorFull = false"><i class="bi bi-fullscreen-exit fs-3 text-white"></i></a>
            <a v-else class="icon" @click="editorFull = true"><i class="bi bi-fullscreen fs-3 text-white"></i></a>
            <div v-show="editorValidResults.length > 0">
              <b-dropdown ref="editorValid" left variant="link" toggle-class="p-0" menu-class="editor_valid bg-light-danger" no-caret>
                <template #button-content>
                  <div class="position-relative">
                    <a class="icon btn btn-sm btn-icon btn-circle btn-icon-danger btn-active-light-danger"><i class="bi bi-bell-fill fs-3"></i></a>
                    <span class="position-absolute top-25 start-100 translate-middle badge badge-sm badge-circle badge-light-danger fs-9" v-text="editorValidResults.length"></span>
                  </div>
                </template>
                <b-dropdown-form>
                  <div class="d-flex justify-content-between align-items-center">
                    <h2 class="m-0">{{ $t('유효성 검사') }}</h2>
                    <div class="btn btn-xs btn-icon btn-color-gray-800 btn-active-color-primary close">
                      <i class="bi bi-x fs-1" @click.stop="$refs.editorValid.hide(true)"></i>
                    </div>
                  </div>
                  <div class="editor_valid_results">
                    <ul>
                      <li v-for="result of editorValidResults">
                        <b v-if="result.type == 'error'" class="badge badge-sm badge-danger" v-text="$t('오류')"></b>
                        <b v-else-if="result.type == 'warning'" class="badge badge-sm badge-warning" v-text="$t('경고')"></b>
                        <div class="link-all" @click="clickEditorValidResult(result)">
                          <span class="ms-2">{{ result.message }}</span>
                          <i class="bi bi-eye ms-2"></i>
                        </div>
                      </li>
                    </ul>
                  </div>
                </b-dropdown-form>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div v-else class="card p-6">
          <div class="card-header" style="padding:0 7px">
            <div class="card-title fw-bold">
              {{ $t('기본정보') }}
            </div>
            <div class="text-right">
              <a class="btn btn-light-primary" @click="action({ action: '상세설정' })" v-text="$t('상세설정')" />
            </div>
          </div>
          <div class="p-4">
            <b-form-group :label="$t('템플릿명')" label-class="required" label-cols="1">
              <b-form-input maxlength="100" v-model="tmpl.tmplNm" />
            </b-form-group>
          </div>
          <div class="p-4">
            <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
              <b-icon icon="file-earmark-pdf" scale="1.3" variant="primary" class="me-3" />{{ $t('첨부문서') }}
              <small v-if="!isMyTmpl" v-text="`(${$t('드래그하여 순서조정')})`" />
            </h4>
            <b-col>
              <draggable @change="seqChanged($event, 'di')" :disabled="isMyTmpl" v-model="tmpl.tmplDocList" v-bind="dragOptions"
                class="row attached-doc-list">
                <div v-for="(item, i) in tmpl.tmplDocList" @click="showDoc(item)" :key="i">
                  <!-- <b-icon icon="file-earmark-pdf" scale="3" variant="secondary" /> -->
                  <img :src="$url(item.thumbUrl)"> {{ item.docNm }}
                  <b-icon v-if="!isMyTmpl" @click.stop="delTmplDoc(i)" icon="x-circle-fill" scale="1.5" variant="danger"
                    class="hover" />
                </div>
              </draggable>
              <b-row v-if="!isMyTmpl" class="attached-doc-list ms-3">
                <div v-b-Modal.첨부추가>
                  <b-icon icon="plus-circle-fill" scale="3" variant="secondary" />
                </div>
              </b-row>
            </b-col>
          </div>
          <div class="p-4">
            <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
              <b-icon icon="person" scale="1.3" variant="primary" class="me-3" />{{ $t('참여자 역할') }}
              <small v-if="!isMyTmpl" v-text="`(${$t('드래그하여 순서조정')})`" />
              <a v-if="!isMyTmpl" @click="addRole" class="btn btn-sm btn-primary" style="float:right;margin-top:-11px"
                v-text="`+ ${$t('추가')}`" />
            </h4>
            <draggable @change="seqChanged($event, 'ui')" :disabled="isMyTmpl" v-model="tmpl.tmplRoleList" v-bind="dragOptions" class="role-list">
              <b-col v-for="(item, i) in tmpl.tmplRoleList" :key="i">
                <b-col style="flex-grow:1">
                  <div class="color" :class="'ctrl-' + i" />
                  <div>
                    <label>{{$t('역할')}}<span class="text-danger ms-1">*</span></label>
                    <b-form-input maxlength="100" :disabled="isMyTmpl" :readonly="isMyTmpl" v-model="item.roleNm"
                      required />
                  </div>
                  <template v-if="item.openType != 'LINK'">
                    <div>
                      <label>{{$t('성명')}}<span class="text-danger ms-1">*</span></label>
                      <div class="icon-btn icon-btn-left icon-btn-right">
                        <b-form-input maxlength="100" :value="item.partiNm || item.grpNm" :readonly="true" @click="openPartiSelTree(i + 1)"></b-form-input>
                        <a class="icon-left icon btn btn-sm btn-icon btn-circle btn-icon-dark btn-active-light-primary" :title="$t('조직도 선택')" @click="openPartiSelTree(i + 1)">
                          <i class="bi bi-person-lines-fill fs-3"></i>
                        </a>
                        <a class="icon-right icon btn btn-sm btn-icon btn-circle btn-icon-dark btn-active-light-danger" :title="$t('제거')" @click="removeParti(i + 1, item)">
                          <i class="bi bi-x fs-3"></i>
                        </a>
                      </div>
                    </div>
                    <div>
                      <label>{{$t('이메일')}}<span class="text-danger ms-1">*</span></label>
                      <b-form-input class="min-w-250px" maxlength="100" :value="item.partiEmail" :readonly="true" @click="openPartiSelTree(i + 1)"></b-form-input>
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      <label>{{$t('성명')}}<span class="text-danger ms-1">*</span></label>
                      <div class="icon-btn icon-btn-right">
                        <b-form-input maxlength="100" :value="item.partiNm || item.grpNm"
                          @change="partiNm => Object.assign(item, { partiNm, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined })" />
                        <a class="icon-right icon btn btn-sm btn-icon btn-circle btn-icon-dark btn-active-light-danger" :title="$t('제거')" @click="removeParti(i + 1, item)">
                          <i class="bi bi-x fs-3"></i>
                        </a>
                      </div>
                    </div>
                    <div>
                      <label>{{$t('이메일')}}<span class="text-danger ms-1">*</span></label>
                      <b-form-input class="min-w-250px" maxlength="100" :value="item.partiEmail"
                        @change="partiEmail => Object.assign(item, { partiEmail, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined })" />
                    </div>
                  </template>                  
                  <div>
                    <label v-text="$t('작성완료방법')" />
                    <b-form-select :disabled="isMyTmpl" :readonly="isMyTmpl" v-model="item.confType"
                      :options="$code('TMPL_CONF_TYPE')" />
                    <!-- <b-form-input disabled readonly
                      :value="($code('TMPL_CONF_TYPE').find(t => t.value == item.confType) || {}).text" /> -->
                  </div>
                  <div v-if="item.openType != 'LOGIN'">
                    <label v-text="$t('인증코드')" />
                    <b-form-input v-model="tmpl.tmplRoleList[i].authCode" />
                  </div>
                </b-col>
                <b-icon v-if="!isMyTmpl"
                  @click="seqChanged({ removed: { oldIndex: i } }, 'ui'); tmpl.tmplRoleList.splice(i, 1)"
                  icon="x-circle-fill" scale="1.5" variant="danger" class="hover" />
                <a @click="role = item; $bvModal.show('참여자 상세설정')" style="white-space:nowrap;float:right"
                  class="btn btn-sm btn-light-primary">상세설정</a>
              </b-col>
            </draggable>
            <div v-if="tmpl.tmplRoleList.length == 0" class="gray-txt p-4" v-text="$t('참여자를 추가하세요.')" />
          </div>
        </div>
        <div v-if="editorStep" class="text-right mt-5">
          <a class="btn btn-secondary me-3" @click="signerStepBack" v-text="$t('이전단계')" />
          <a class="btn btn-warning me-3" @click="save({ statusCd: 'TEMP' })" v-text="$t('임시저장')" />
          <a class="btn btn-primary" @click="save({ statusCd: 'SAVE', nextStep: true })" v-text="$t('템플릿저장')" />
        </div>
        <div v-else class="text-right mt-5">
          <a class="btn btn-warning me-3" @click="save({ statusCd: 'TEMP' })" v-text="$t('임시저장')" />
          <a class="btn btn-primary" @click="save({ statusCd: 'TEMP', nextStep: true })" v-text="$t('다음단계')" />
        </div>
      </template>
      <b-modal id="참여자추가" dialog-class="min-w-1024px" body-class="p-5 pt-3" :title="$t('참여자 추가')" hide-footer>
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-between mb-2">
            <div class="d-flex justify-content-end">
              <div class="d-flex align-items-center position-relative">
                <b-icon icon="search" />
                <input type="text" v-model="partiParams.searchKeyword" class="form-control form-control-solid form-control ps-11 pe-12 w-500px border-def" maxlength="100"
                  :placeholder="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                  :title="$t('조직명, Cust Abbr., 사용자명, 아이디, 이메일, 그룹명')"
                  @keydown="onTyping = true" 
                  @keyup.enter="searchPartiMemberList">
                <a v-if="partiParams.searchKeyword" @click="removeSearchPartiMember"
                  class="icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary position-absolute end-0 me-1">
                  <i class="bi bi-x-circle fs-3"></i>
                </a>
              </div>
              <a class="btn btn-secondary ms-1" :class="{'d-none': !partiSearchMode}" @click="removeSearchPartiMember">
                <i class="bi bi-arrow-left-short"></i>{{ $t('조직도') }}
              </a>
            </div>
            <b-button v-if="!unmaskKey && (allPartiMemberList.length || partiMemberList.length)" class="btn-sm" @click="reqUnmask()" variant="warning">
              {{ $t('마스킹 해제') }}
            </b-button>
          </div>
          <div style="height: 64vh;" class="row">
            <div class="h-100 d-flex" :class="{'d-none': partiSearchMode}">
              <div class="h-100" style="width: 38%;">
                <TreeView2 size="lg" :treeData="partiSelTree" @clicked="choicePartiGrp" height="100%" :customAction="partiSelTreeActions"
                  :filterHolder="$t('조직명, 그룹명')" showOuterBorder closeAll></TreeView2>
              </div>
              <div class="h-100 ms-4" style="width: 62%;">
                <div class="ps-2" style="height: 30px;">
                  <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
                </div>
                <div style="height: calc(100% - 30px)">
                  <TableView ref="partiMemberTable" class="table-break-all" :list="partiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                    min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                    :columns="[
                      { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                      { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                    ]">
                  </TableView>
                </div>
              </div>
            </div>
            <div class="h-100" style="width: 100%;" :class="{'d-none': !partiSearchMode}">
              <div class="ps-2" style="height: 30px;">
                <span v-text="$t('$ 명', [partiSearchMode ? allPartiMemberList.length : partiMemberList.length])"></span>
              </div>
              <div style="height: calc(100% - 30px)">
                <TableView ref="allPartiMemberTable" class="table-break-all" :list="allPartiMemberList" :actions="['선택']" actionSize="xs" hideActionLabel 
                  min-width="auto" height="100%" minHeight="150px" hidePagination showOuterBorder @action="assignPartiMember"
                  :columns="[
                    { key: 'custAbbr', label: 'Cust Abbr.', style: { textAlign: 'center' } },
                    { key: 'custName', label: '조직명', style: { textAlign: 'center' } },
                    { key: 'custFullName', label: '조직영문명', style: { textAlign: 'center' } },
                    { label: '사용자', renderer: r => `${r.userNm} (${r.userIdText})`, style: { textAlign: 'center' } },
                    { key: 'email', label: '이메일', style: { textAlign: 'center' } },
                    { key: 'grpNm', label: '그룹', style: { textAlign: 'center' } },
                  ]">
                </TableView>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <ModalForm :ok-only="!!isMyTmpl" id="상세설정" ok-title="템플릿에 반영" form-only :spec="[
        { label: '템플릿키', key: 'tmplKey' },
        { label: '설명', key: 'description', type: 'textarea' },
        { label: '발효일', key: 'effectDt', type: 'date' },
        { label: '만료일', key: 'expireDt', type: 'date' },
        { label: '만료 알림', key: 'bfExpireNotiDay', default: 0, type: 'number', append: $t('일전') },
        { label: '보안등급', key: 'securityRating', default: '5', options: $code('EDOC_SECURITY_RATING') },
        { label: 'Product', key: 'prodId', default: '', options: $code('PRODUCT') },
        { label: 'e-봉투 유효기간', key: 'signValidDay', default: 90, type: 'number', append: $t('일') },
        { label: '미확인 시 알림', key: 'unconfNotiDay', default: 0, type: 'number', append: $t('일 경과') },
        { label: '서명 권한 위임', key: 'signMandateYn', default: 'N', type: 'radio', options: $code('POSS') },
        { label: 'TAG', key: 'tag', type: 'tag' },
      ]" @action="({ form }) => Object.assign(tmpl, form)" :data="tmpl" />
      <b-modal size="lg" hide-footer @show="selectAttachDocList" title="첨부문서 추가" id="첨부추가">
        <b-input-group style="margin:0 1em;width:calc(100% - 2.5em);z-index:1">
          <!-- <b-input-group-prepend>
            <b-form-select class="h-100" size="lg" v-model="selDocFilter.grpId" :options="['미즈호', '본인 조직']" />
          </b-input-group-prepend> -->
          <b-form-input maxlength="100" v-model="selDocFilter.searchKeyword" :placeholder="$t('문서명, 문서명보조, 원본파일명')"
            title="문서명, 문서명보조, 원본파일명" />
          <b-input-group-append>
            <b-button variant="primary" v-text="$t('검색')" />
          </b-input-group-append>
        </b-input-group>
        <TableView hide-thead style="margin-top:-25px;background-color:transparent" @action="addDoc" :actions="['문서 선택']"
          min-width="auto" min-height="auto"
          :list="attachDocList.filter(d => !selDocFilter.searchKeyword || Array.of(d.docNm, d.docNmSub || d.docFileNmOrigin).find(v => v.toUpperCase().indexOf(selDocFilter.searchKeyword.toUpperCase()) > -1))"
          :columns="[
            { key: 'rnk' },
            { renderer: r => `<img style='margin:-5px 0;height:3em' src='${$url(r.thumbUrl)}'>` },
            { renderer: (r, s) => `${r.docNm} (${r.docFileNmOrigin})${r.pwdExist ? `<i class='bi bi-lock-fill text-primary ms-2'></i>` : ''}` },
          ]">
          <div slot="thead" />
        </TableView>
      </b-modal>
    </template>
    <!-- 보기 화면 -->
    <template v-else-if="tmpl && tmpl.tmplId && !tmpl.pwdExist">
      <template slot="previous">
        <a class="btn btn-icon btn-active-secondary rounded-pill" @click="$go('/tmpl');">
          <i class="bi bi-chevron-left fs-2hx"></i>
        </a>
      </template>
      <template slot="toolbar">
        <!-- editorTestMode<b-form-checkbox class="me-9" switch v-model="editorTestMode" /> -->
        <b-button v-if="device == 'WEB'" variant="secondary" @click="goBackToList(listParams.mode, listParams.dirId);" v-text="$t('목록으로')" />
      </template>
      <b-tabs slot="content" lazy>
        <b-tab :title="$t('기본정보')" class="card p-6">
          <div class="card-header" style="padding:0 7px">
            <div class="card-title fw-bold">              
              <b class="badge me-2" :class="[`badge-light-${tmpl.statusClass}`]">{{tmpl.statusNm}}</b>
              <b v-if="tmpl.expired" class="badge me-2" :class="[`badge-light-${tmpl.expiredClass}`]">{{tmpl.expiredNm}}</b>
              <span>{{ $unescapeHtml(tmpl.tmplNm) }}</span>
              <span class="fs-7 text-gray-400 ms-2">{{ $unescapeHtml(tmpl.description) }}</span>
            </div>
            <div class="card-toolbar">
              <b-button v-if="auths.includes('MAIN_TMPL_UPD') || auths.includes('MAIN_TMPL_SUB')"
                :disabled="!tmpl.editable" variant="light-primary" @click="$go(`/tmpl?crud=수정&id=${tmpl.tmplId}&mode=${listParams.mode || 'all'}&dirId=${listParams.dirId || ''}`)">
                <b-icon icon="pencil" /> {{ $t('수정') }}</b-button>
              <div v-if="auths.includes('MAIN_TMPL_DEL') || auths.includes('MAIN_TMPL_SUB')">
                <b-button v-if="tmpl.deletable" class="ms-3" variant="danger" @click="action({ action: '영구삭제' })">
                  <b-icon icon="trash" /> {{ $t('영구삭제') }}</b-button>
                <b-button v-else class="ms-3" :disabled="!tmpl.trashable" variant="danger"
                  @click="action({ action: '휴지통 이동' })">
                  <b-icon icon="trash" /> {{ $t('휴지통') }}</b-button>
              </div>
            </div>
          </div>
          <ItemView :items="[
            {
              템플릿키: tmpl.tmplKey,
              만료일: tmpl.expireDt ? tmpl.expireDt.f('date') : '',
              보안등급: tmpl.securityRatingNm,
              Product: tmpl.prodNm,
              '미확인 시 알림': `${$t('$ 일 경과', [tmpl.unconfNotiDay || ''])}`,              
            },
            {
              발효일: tmpl.effectDt ? tmpl.effectDt.f('date') : '',
              '만료 알림': `${$t('$ 일전', [tmpl.bfExpireNotiDay || ''])}`,
              'e-봉투 유효기간': tmpl.signValidDay + $t('일'),
              '서명 권한 위임': ({ Y: $t('가능'), N: $t('불가능') })[tmpl.signMandateYn],
              TAG: { slot: 'TAG' },
            },
          ]">
            <template slot="TAG"><b-badge v-for="(tag, i) in (tmpl.tag || '').split(',')" :key="i" v-text="tag" /></template>
          </ItemView>
          <div class="p-4 mt-5">
            <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
              <b-icon icon="file-earmark-pdf" scale="1.3" variant="primary" class="me-3" />{{ $t('첨부문서') }}
            </h4>
            <b-row class="attached-doc-list">
              <div @click="showDoc(item)" v-for="(item, i) in tmpl.tmplDocList" :key="i">
                <img :src="$url(item.thumbUrl)"> {{ item.docNm }}
              </div>
            </b-row>
          </div>
          <div class="p-4">
            <h4 class="pb-3" style="border-bottom:1px dashed #ccc">
              <b-icon icon="person" scale="1.3" variant="primary" class="me-3" />{{ $t('참여자 역할') }}
            </h4>
            <div class="role-list">
              <b-col v-for="(item, i) in tmpl.tmplRoleList" :key="i">
                <b-col style="flex-grow:1">
                  <div class="color" :class="'ctrl-' + i" />
                  <div>
                    <label v-text="$t('역할')" />
                    <b-form-input readonly v-model="item.roleNm" />
                  </div>
                  <div>
                    <label v-text="$t('성명')" />
                    <b-form-input readonly :value="item.partiNm || item.grpNm" />
                  </div>
                  <div>
                    <label v-text="$t('이메일')" />
                    <b-form-input class="min-w-250px" readonly :value="item.partiEmail" />
                  </div>
                  <div>
                    <label v-text="$t('작성완료방법')" />
                    <b-form-input readonly
                      :value="($code('TMPL_CONF_TYPE').find(t => t.value == item.confType) || {}).text" />
                  </div>
                  <div v-if="item.openType != 'LOGIN'">
                    <label v-text="$t('인증코드')" />
                    <b-form-input readonly v-model="item.authCode" />
                  </div>
                </b-col>
                <a @click="role = item; $nextTick(() => $bvModal.show('참여자 상세설정'))" style="white-space:nowrap;float:right"
                  class="btn btn-sm btn-light-primary">상세설정</a>
              </b-col>
            </div>
          </div>
        </b-tab>
        <b-tab :title="$t('문서정보')" style="position:relative">
          <b-embed :class="{ full: editorFull }" class="embed" style="border-radius:0.65rem;border-top-left-radius:0" :src="`${signerBase}${tmpl.tmplId}?disable=${isMyTmpl ? 'valueonly' : 'true'}`" />
          <div class="editor-header-left gap-3" :class="{ 'fullscreen': editorFull }">
            <a v-if="editorFull == true" class="icon" @click="editorFull = false"><i class="bi bi-fullscreen-exit fs-3 text-white"></i></a>
            <a v-else class="icon" @click="editorFull = true"><i class="bi bi-fullscreen fs-3 text-white"></i></a>
          </div>
        </b-tab>
      </b-tabs>
    </template>
    <!-- 목록 화면 -->
    <template v-if="!tmpl || tmpl.pwdExist" slot="sub_title">{{ this.subTitle }}</template>

    <div v-if="!tmpl || tmpl.pwdExist" slot="left" class="w-225px">
      <b-button v-if="auths.includes('MAIN_TMPL_INS')" class="mb-2" variant="primary" block @click="$go('/tmpl?crud=추가')" v-text="$t('템플릿 만들기')" />
      <MenuView class="mb-3" ref="menuView" @clicked="onMenu" :menus="tmplMenus" />
      <TreeView class="mb-3" ref="treeView" @context="contextTree" @clicked="({ item }) => onTree(item, title, key)" v-for="(title, key, i) in dirs" :key="i" :title="title" labelKey="dirNm" :tree="dirTree[key]" :hasContextMenu="true" />
    </div>
    <TableView v-show="!tmpl || tmpl.pwdExist" :keep-page="keepPage" slot="content" class="tmpl"
      :list="list" :server-total="serverTotal" @nextList="getList()"
      :columns="tmplColumns"
      :filters="device == 'WEB' ? filter : []"
      @action="action"
      :actions="[
        (auths.includes('MAIN_ENV') ? 'e-봉투 만들기' : null), 
        (auths.includes('MAIN_TMPL_SUB') ? '내 템플릿 만들기' : null), 
        (auths.includes('MAIN_TMPL_SUB') ? '복사' : null),
      ]"
      :action-filter="(item, action) => 
        (action == 'e-봉투 만들기' && item.statusCd == 'CONF' && !item.expired) ||
        (action == '내 템플릿 만들기' && item.pTmplId == '0' && item.statusCd == 'CONF' && !item.expired) ||
        (action == '복사' && item.statusCd == 'CONF' && !item.expired)
      "
      :check-actions="[
        (auths.includes('MAIN_TMPL_STATUS') ? {text: '등록완료', variant: 'success'} : null),
        (auths.includes('MAIN_TMPL_STATUS') ? {text: '등록취소', variant: 'danger'} : null),
        (auths.includes('MAIN_TMPL_DIR_MOVE') || auths.includes('MAIN_TMPL_SUB') ? {text: '폴더이동', variant: 'secondary'} : null)
      ]">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input maxlength="100" id="listSearchKeyword" @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-200px ps-11" 
          :placeholder="$t('템플릿명, 템플릿키, 등록자')" :title="$t('템플릿명, 템플릿키, 등록자')" v-b-tooltip.hover />
      </div>
      <b-button variant="light-primary" v-b-modal.상세>
        <b-icon icon="filter" /> {{ $t('상세') }}
      </b-button>
    </TableView>
    <ModalForm id="상세" size="sm" @cancel="detailSearch({})" @action="detailSearch" modal-class="border-none" title="발효일"
      label-cols="0" ok-title="검색" cancel-title="초기화" :data="detail" form-only
      :spec="[{ type: 'date-between', key: 'effectDt' }]" close-on-backdrop />
    <ModalForm id="내 템플릿 만들기" @action="action" modal-class="border-none" title="내 템플릿 만들기" label-cols="3" ok-title="저장"
      :data="subTmpl" form-only
      :spec="[{ label: '템플릿명', key: 'tmplNm', required: true }, { label: '설명', key: 'description', type: 'textarea' }]" />
    <ModalForm id="복사" @action="action" modal-class="border-none" title="복사" label-cols="3" ok-title="저장"
      :data="subTmpl" form-only
      :spec="[{ label: '템플릿명', key: 'tmplNm', required: true }, { label: '설명', key: 'description', type: 'textarea' }]" />
    <ModalForm id="dirModal" size="sm" modal-class="border-none" label-cols="0" :data="dirModal.data"
      @action="({ form }) => contextTreeAction(dirModal.act, dirModal.item, form)" :title="dirModal.title" form-only
      :spec="[{ placeholder: '폴더명', key: 'dirNm' }]">
      <div class="mb-3 gray-txt" v-html="`${this.$t('대상폴더명')}: ${dirModal.item && dirModal.item.dirNm}`" />
    </ModalForm>
    <b-modal id="순서변경" centered scrollable hide-footer size="sm" :title="$t('폴더 순서변경')">
      {{ $t('드래그하여 순서조정') }}
      <draggable class="dir-sibling" v-model="dirSibling" v-bind="dragOptions" @change="contextTreeAction('순서변경')">
        <div :key="i" v-for="(dir, i) in dirSibling">
          {{ dir.dirNm }}<b-icon icon="arrows-move" />
        </div>
      </draggable>
    </b-modal>
    <b-modal id="일괄 폴더이동" size="sm" :title="$t('폴더이동')" @close="getDirId('close')" @cancel="getDirId('cancel')"
      @ok="event => action({ action: '일괄 폴더이동', event })" :ok-title="$t('저장')" :cancel-title="$t('취소')">
      <TreeView v-for="(title, key, i) in getDirMy ? { MY: '내 템플릿' } : dirs" tree-id="move" :key="i"
        @clicked="({ item }) => selFolder = item" radio :title="title" class="p-3" labelKey="dirNm"
        :tree="dirTree[key]" />
    </b-modal>
    <ModalForm id="참여자 상세설정" @action="({ form }) => role = Object.assign(role, form)" :ok-only="!crud || !!isMyTmpl"
      :ok-title="crud ? '저장' : '확인'" form-only :spec="[
        { label: '수행업무', key: 'taskId', default: '', options: $code('TASK') },
        { label: 'e-봉투 개봉방법', key: 'openType', options: $code('TMPL_OPEN') },
        { label: 'e-봉투 조회권한', key: 'viewType', options: $code('ENV_VIEW_TYPE') },
        { label: '메시지 사용', key: 'msgUseType', default: 'VIEW_WRITE', options: $code('TMPL_MSG_USE_TYPE') },
        { label: '회람 완료 시', key: 'atEndRcvCd', default: 'NOTI_ENVFILE_ATTACH', options: $code('TMPL_AT_END_RCV') },
        { label: '위임자 추가', key: 'partiAddPossYn', default: 'N', type: 'radio', options: $code('POSS') },
        { label: '다음 참여자 추가', key: 'checkerAddPossYn', default: 'N', type: 'radio', options: $code('POSS') },
        { label: '메시지', key: 'guide', type: 'textarea' },
      ]" :data="role" />
    <b-modal v-if="doc.docFileUrl" modal-class="full" id="파일보기" :title="doc.docNm" hide-footer centered>
      <b-embed :src="$url(doc.docFileUrl)" allowfullscreen />
    </b-modal>
    <div id="canvasDiv" style="display:none"></div>
  </Layout>
</template>

<script>
import draggable from 'vuedraggable';
import Layout from "@/components/layout/Layout.vue";
import TreeView from "@/components/TreeView.vue";
import TreeView2 from "@/components/TreeView2.vue";
import TableView from "@/components/TableView.vue";
import MenuView from "@/components/MenuView.vue";
import ModalForm from "@/components/ModalForm.vue";
import ItemView from "@/components/ItemView.vue";
const dirMaper = { MY: 'My', SHARE: 'Share', CUST: 'Cust' };
const taskIdCheck = 'CHECK';

export default {
  components: { draggable, Layout, TreeView, TreeView2, TableView, MenuView, ModalForm, ItemView },
  computed: {
    crud() { return this.$route.query.crud },
    isMyTmpl() { return this.tmpl && this.tmpl.pTmplId && this.tmpl.pTmplId != '0' },
    auths() { return this.$store.state.user.auths || [] },
    dragOptions() { return { animation: 250, ghostClass: "ghost" }; },
    device() { return this.$getDevice(); },
    defListParams() { return { mode: 'all', dirId: '', statusCd: null, prodId: null, searchKeyword: '', effectDtFrom: '', effectDtTo: '' }; },
    defDetail() { return { effectDt: ['', ''] }; },
  },
  data: () => ({
    tmplMenus: [
      { icon: 'stack', label: '전체 템플릿', key: 'all' }, 
      { color: 'warning', icon: 'star-fill', label: '즐겨찾기', key: 'favorite' },
      { icon: 'trash', label: '휴지통', key: 'trash', color: 'danger' },
    ],
    subTitle: '', tmplDirList: [],
    keepPage: false, changedCtrls: {}, docPwds: null,
    attachDocParams: { dirId: '', searchKeyword: '' }, attachDocList: [], selDocFilter: {},
    tmplColumns: [
      {
        label: '상태', key: 'statusNm', style: { textAlign: 'center' }, renderer: r => {
          let statusEl = `<b class="badge badge-light-${r.statusClass}">${r.statusNm}</b>`;
          if(r.expired) statusEl += `<div class="mt-1"><b class="badge badge-sm badge-light-${r.expiredClass}">${r.expiredNm}</b></div>`;
          return statusEl;
        } 
      },
      { 
        label: '템플릿명', style: { fontWeight: 'bold', minWidth: '160px', maxWidth: '240px' },
        renderer: (r, s) => {
          return `
            <div class="d-flex">
              ${r.pTmplId == 0 ? '' : '<div class="pe-2"><i class="bi bi-copy fs-5" title="Copy"></i></div>'}
              <div>
                ${s.$unescapeHtml(r.tmplNm)}${r.pwdExist ? `<i class="bi bi-lock-fill text-primary ms-2"></i>` : ''}
                ${r.pTmplId == 0 ? '' : `<div class='fs-8 text-gray-500'>${s.$unescapeHtml(r.pTmplNm)}</div>`}
                ${r.tag ? `<div class="text-primary fs-8 fw-normal">${r.tag.f('tag_exp')}</div>` : ''}
              </div>
            </div>
          `;
        },
      },
      { label: '문서', key: 'docNm', renderer: r => r.tmplDocList.map(({ docNm }, i) => `${i + 1}. ${docNm}`).join('<br>') },
      { label: 'Product', key: 'prodNm', style: { textAlign: 'center' } },
      { label: '발효일', key: 'effectDt', type: 'date', style: { textAlign: 'center' } },
      { label: '등록자\n등록일', renderer: r => `${r.modUserNm}${r.modUserId != 0 && ` (${r.modUserId})` || ''}<br>${r.modDt.f('datetime-local')}`, style: { whiteSpace: 'nowrap', textAlign: 'center' } },
      { label: '등록자', key: 'modUserNm', hide: ['td'] },
      {
        label: '즐겨찾기', style: { textAlign: 'center' }, 
        renderer: (r) => {
          const variant = r.favYn == 'Y' ? 'warning' : 'secondary';
          return `
            <a class="btn btn-sm btn-icon btn-circle btn-icon-${variant} btn-active-light-dark" data-u="favoriteTmpl">
              <i class="bi bi-star-fill fs-3 text-${variant}" data-u="favoriteTmpl"></i>
            </a>
          `;
        }
      },
      // { label: '문서', key: 'docNm', renderer: r => r.tmplDocList.map(({ docNm }, i) => `${i + 1}. ${docNm}`).join('<br>'), style: { verticalAlign: 'top' } },
    ],    
    listParams: null, detail: null,
    serverTotal: 0, filter: [{ key: 'statusCd', label: '상태', cd: 'TMPL_STATUS' }, { key: 'prodId', label: 'Product', cd: 'PRODUCT' }],
    dirTree: { MY: [], SHARE: [], CUST: [] }, dirs: {}, dirAct: [],
    sel: null, tmpl: null, list: [], doc: {}, role: {}, defaultRole: {}, editorScope: null, dirSibling: [], editorFull: false,
    subTmpl: {}, signerBase: '/signer/editor/', editorStep: false, editorTestMode: false, dirModal: {}, getDirIdRes: null, getDirMy: false,
    partiSelTree: '', unmaskKey: '', onTyping: false, partiSearchMode: false,
    partiMemberList: [], allPartiMemberList: [], partiParams: { selType: '', selKey: '', searchKeyword: '' }, 
    editorValidResults: [],
  }),
  created() {
    // 템플릿 폴더 권한 처리
    if (this.auths.includes('MAIN_TMPL_MY_DIR_SEL')) {
      this.dirs['MY'] = '내 템플릿';
      this.dirAct.push('My');
    }

    if (this.auths.includes('MAIN_TMPL_SHARE_DIR_SEL')) {
      this.dirs['SHARE'] = '공유 템플릿';
      this.dirAct.push('Share');
    }

    if (this.auths.includes('MAIN_TMPL_CUST_DIR_SEL')) {
      this.dirs['CUST'] = '조직 템플릿';
      this.dirAct.push('Cust');
    }

    this.$setProdTask();
    this.setTree();

    if(this.listParams == null) this.listParams = this.defListParams;
    if(this.detail == null) this.detail = this.defDetail;

    // 사이너 에디터를 위한 인터페이스
    window.ktdp = editorScope => new Promise(async (resolve, reject) => {
      const { tmplId, pTmplId, tmplRoleList } = this.tmpl;
      this.editorScope = editorScope;
      let { data } = await this.$api('main/tmpl/selectTmplEditor', { tmplId });
      if (!data && pTmplId && pTmplId != '0') data = (await this.$api('main/tmpl/selectTmplEditor', { tmplId: pTmplId })).data;
      const title = this.$t('문서 변환 중...');
      await this.$store.commit('progress', { title, progress: 1 });
      await this.$loadScript('/libs/pdf.min.3.0.279.js');
      await this.$loadScript('/libs/pdf2png.js');
      let { tmplDocList } = this.tmpl || this.sel;
      if (!data) data = {};
      data.users = tmplRoleList.map((r, i) => Object.assign(r, { i: i + '' })).map(r => {
        return { name: r.roleNm, i: r.i, h: r.confType == 'ENV_REF' || r.taskId == taskIdCheck };
      });
      try {
        data.ctrls = data.jsonCtrls ? JSON.parse(data.jsonCtrls) : [];
        data.docs = [];
        if (tmplDocList.length == 0) throw 'error no tmplDocList';
        for (const doc of tmplDocList)
          data.docs.push({
            name: doc.docNm,
            pages: await window.pdf2png(this.$url(doc.docFileUrl), window.canvasDiv, (page, total) => this.$store.commit('progress', { title, progress: Math.round(page * 100 / total) }))
          });
      } catch (e) {
        this.$store.commit('progress', { progress: 100 });
        await this.$alert(`<pre>${this.$t('문서를 가져오는데 실패했습니다.<br>($)', [e + ''])}</pre>`, { size: 'lg' });
        reject(e);
        this.$go(-1);
      }
      this.$store.commit('progress', { progress: 100 });
      resolve(data);
    });
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if(newQuery.crud || newQuery.id) {
          this.selTmpl(newQuery.crud, newQuery.id, newQuery.mode, newQuery.dirId);
        } else {
          this.tmpl = null;
          if(this.listParams != null) {
            this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId}, false);
          }
        }
      }
    },
    listParams: {
      deep: true,
      handler() {
        this.getList(true);
      }
    },
  },
  methods: {
    async goBackToList(mode, dirId) {
      this.$router.push(`/tmpl`).then(() => {
        this.changeMode({ mode, dirId }, false);
      });
    },
    async changeMode(params, reset = true) {
      this.$nextTick(() => {
        const mode = params.mode || 'all';
        const dirId = params.dirId || '';

        if(mode == 'dir') {
          // 폴더 선택
          if(this.$refs.treeView[0]) { this.$refs.treeView[0].selectByKey(dirId); }
          if(this.$refs.treeView[1]) { this.$refs.treeView[1].selectByKey(dirId); }
          if(this.$refs.treeView[2]) { this.$refs.treeView[2].selectByKey(dirId); }
        } else {
          // 메뉴 선택
          if(this.$refs.menuView) { this.$refs.menuView.selectByKey(mode); }
        }

        // 템플릿 목록 리프레쉬
        if(reset) {
          Object.assign(this.listParams, { mode, dirId });
        }
      });
    },
    partiSelTreeActions(item) {
      return item.grpId ? `<span class="btn btn-xs btn-light-primary" action="grp_sel">${this.$t('선택')}</span>` : ``;
    },
    async choicePartiGrp({item, action} = {}) {
      if(action == 'grp_sel') {   
        this.assignPartiMember({item});
        return;
      } else {
        this.onTyping = false;
        this.partiParams.selType = item.type;
        this.partiParams.selKey = item.key;
        this.partiParams.searchKeyword = '';
        this.unmaskKey = '';
        this.selectPartiMemberList(item.type == 'cust' ? {selCustId: item.key} : {selGrpId: item.key});
      }
    },
    async searchPartiMemberList() {
      if(this.partiParams.searchKeyword) {
        this.onTyping = false;
        this.unmaskKey = '';
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword});
      }
    },
    async removeSearchPartiMember() {
      this.partiParams.searchKeyword = '';
      this.partiSearchMode = false;
      this.unmaskKey = '';
    },
    async reqUnmask() {
      const { success, msg, data } = await this.$api('cmm/unmask', { unmaskActCd: 'TMPL_SRC_MEMBER' });
      if (!success) return this.$alert(msg);
      this.unmaskKey = data.unmaskKey;
      if(this.partiSearchMode) {
        this.selectPartiMemberList({searchKeyword: this.partiParams.searchKeyword, unmaskKey: this.unmaskKey});
      } else {
        let params = this.partiParams.selType == 'cust' ? {selCustId: this.partiParams.selKey} : {selGrpId: this.partiParams.selKey};
        params.unmaskKey = this.unmaskKey;
        this.selectPartiMemberList(params);
      }
    },
    async selectPartiMemberList(params) {
      if(!this.onTyping) {
        if(this.partiParams.searchKeyword) { // 검색 모드
          this.allPartiMemberList = [];
          const resultList = (await this.$api('main/tmpl/selectPartiMemberList', params)).list;
          this.allPartiMemberList = [...resultList];
          this.partiSearchMode = true;
        } else {
          this.partiMemberList = [];
          const resultList = (await this.$api('main/tmpl/selectPartiMemberList', params)).list;
          this.partiMemberList = [...resultList];
          this.partiSearchMode = false;
        }
        this.onTyping = false;
      }
    },
    async assignPartiMember({item}) {
      const res = (await this.$api('main/tmpl/validParti', {memberId: item.memberId || '', grpId: item.grpId || '', roleNm: this.role.roleNm || '', prodId: this.tmpl.prodId || '', taskId: this.role.taskId || ''}));
      if(res.success) {
        let selParti;
        if(item.userId) { // 멤버 선택
          selParti = { partiNm: item.userNm, partiEmail: item.email, userId: item.userId, memberId: item.memberId, grpId: undefined, grpNm: undefined };
        } else { // 그룹 선택
          selParti = { partiNm: item.grpNm, partiEmail: undefined, userId: undefined, memberId: undefined, grpId: item.grpId };
        }
        Object.assign(this.role, selParti);
        this.$forceUpdate();
        this.$bvModal.hide('참여자추가');
      } else {
        return this.$alert(res.msg.replace('\n', '<br />'));
      }
    },
    async removeParti(roleSeq, item) {
      this.$set(this.tmpl.tmplRoleList, roleSeq - 1, { ...item, partiNm: undefined, partiEmail: undefined, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined });
      this.$forceUpdate();
    },
    async openPartiSelTree(roleSeq) {
      if (roleSeq) {
        this.role = this.tmpl.tmplRoleList[roleSeq - 1];
      }
      else roleSeq = this.tmpl.tmplRoleList.indexOf(this.role) + 1;
      
      // 매번 초기화
      let custItems = [];
      const custList = (await this.$api('main/tmpl/selectPartiGrpList', {})).list;
      custList.forEach((cust) => {
        let custItem = Object.assign(cust, {icon: 'bi-building-fill', type: 'cust', key: cust.custId, label: cust.custName, children: []});
        custItems.push(custItem);
        for(const grp of cust.grpList) {
          let currItem = grp.pGrpId == 0 ? custItem : cust.grpList.find(d => d.grpId == grp.pGrpId)
          currItem.children.push(Object.assign(grp, {icon: 'bi-people-fill', type: 'grp', key: grp.grpId, label: grp.grpNm, children: []}));
        }
      });

      this.partiSelTree = [...custItems];
      this.partiParams = { selType: '', selKey: '', searchKeyword: '' };
      this.partiSearchMode = false;
      
      // 참여자 목록 초기화
      this.$nextTick(() => {
        this.partiMemberList = [];
        this.allPartiMemberList = [];
      });
      
      this.$bvModal.show('참여자추가');
    },
    async showDoc(item) {
      this.doc = item;
      await this.$delay(100);
      this.$bvModal.show('파일보기');
    },
    async signerStepBack() {
      if (await this.$alert(this.$t('편집중인 내용은 저장되지 않습니다.<br>계속 하시겠습니까?'), { confirm: true }))
        this.editorStep = false;
    },
    addRole() {
      this.seqChanged({ added: {} }, 'ui');
      if (this.tmpl.tmplRoleList.length > 19) return this.$alert('최대치를 초과하였습니다.');
      this.tmpl.tmplRoleList.push({ ...this.defaultRole });
    },
    initParams() {
      document.querySelector('#listSearchKeyword').value = '';
      Object.assign(this.detail, this.defDetail);
      return this.defListParams;
    },
    onMenu(menu) {
      const params = Object.assign(this.initParams(), { mode: menu.key, dirId: '' });
      Object.assign(this.listParams, params);
    },
    onTree(dir, dirNm, ownerType) {
      if (dir) {
        if (!dir.dirId) {
          return;
        } else {
          const params = Object.assign(this.initParams(), { mode: 'dir', dirId: dir.dirId });
          Object.assign(this.listParams, params);
        }
      } else {
        this.dirModal = { data: {}, title: '하위폴더 추가', act: 'insert', item: { dirNm, ownerType, dirId: 0 } };
        this.$bvModal.show('dirModal');
      }
    },
    async setTree(resetCache) {
      let dirIds = [];
      for (const tree of this.dirAct) {
        this.dirTree[tree.toUpperCase()] = [];
        const list = await this.$tree('main/tmpl/selectTmplDirList' + tree, {}, resetCache);
        for (const dir of list) {
          dirIds.push(dir.dirId);
          dir.key = dir.dirId;
          this.tmplDirList.push({...dir});
          if (dir.pDirId > 0) list.find(d => d.dirId == dir.pDirId).children.push(Object.assign(dir, { children: [] }));
          else this.dirTree[tree.toUpperCase()].push(Object.assign(dir, { children: [] }));
        }
      }

      if(resetCache) {
        if(this.listParams.mode == 'dir' && !dirIds.some(dirId => dirId == this.listParams.dirId)) {
          // 해당 폴더가 삭제되었을 경우
          this.changeMode({mode: 'all'});
        } else {
          // 폴더 선택 유지
          this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId});
        }
      }
    },
    async contextTreeAction(act, item, form) {
      if (act == '순서변경') {
        let newSort;
        this.dirSibling.some((dir, i) => {
          if (dir.sort == i + 1) return;
          else if (dir.sort == i + 2) {//뒤쪽에서 찾아야함
            let j = i + 1;
            while (this.dirSibling[j].sort != i + 1) j++;
            item = this.dirSibling[j];
            newSort = j + 1;
          }
          else {// 자신이 옮겨짐
            item = dir;
            newSort = i + 1;
          }
          return true;
        })
        const res = await this.$api('main/tmpl/changeTmplDirSort' + dirMaper[item.ownerType], { dirId: item.dirId, newSort });
        if (res.success) {
          this.$toast(res.msg, { variant: 'success', toaster: 'b-toaster-bottom-right' });
          this.dirSibling.forEach((dir, i) => dir.sort = i + 1);
          this.setTree(true);
        } else {
          this.$alert(res.msg);
        }
        return;
      } else {
        if (!form.dirNm) {
          return this.$alert(this.$t('폴더명을 확인하세요'));
        } else {
          const res = await this.$api(`main/tmpl/${act}TmplDir${dirMaper[item.ownerType]}`, { dirId: item.dirId, pDirId: item.dirId, dirNm: form.dirNm });
          if (res.success) {
            this.setTree(true);
          } else {
            this.$alert(res.msg);
          }
        }
      }
    },
    contextTree({ evt, item, sibling }) {
      this.$store.commit('contextmenu', {
        evt, menu: {
          하위폴더추가: () => {
            this.dirModal = { data: {}, title: '하위폴더 추가', act: 'insert', item };
            this.$bvModal.show('dirModal');
          }, 이름변경: () => {
            this.dirModal = { data: { dirNm: item.dirNm }, title: '폴더 이름변경', act: 'update', item };
            this.$bvModal.show('dirModal');
          }, 순서변경: () => {
            if (sibling.length == 1) return this.$alert(this.$t('형제 폴더가 없습니다.'));
            this.dirSibling = sibling;
            this.$bvModal.show('순서변경');
          }, 삭제: async () => {
            if (!(await this.$alert(this.$t('$ 폴더를 삭제하시겠습니까?', [item.dirNm]), { confirm: true }))) {
              return;
            } else {
              const res = await this.$api('main/tmpl/deleteTmplDir' + dirMaper[item.ownerType], { dirId: item.dirId });
              if (res.success) {
                this.setTree(true);
              } else {
                this.$alert(res.msg);
              }
            }
          }
        }
      });
    },
    async getDirId(evt, my) {
      if (evt) {
        if (this.selFolder) this.getDirIdRes(this.selFolder.dirId);
        this.getDirMy = false;
        this.getDirIdRes = null;
        this.selFolder = null;
      }
      else if (my && this.dirTree.MY.length < 1) {
        this.$alert(this.$t('내 템플릿 폴더 생성 후 등록하세요'));
        return;
      }
      else if (this.dirTree.MY.length + this.dirTree.SHARE.length + this.dirTree.CUST.length < 1) {
        this.$alert(this.$t('폴더 생성 후 등록하세요'));
        return;
      }
      else return new Promise(res => {
        this.getDirMy = false;
        this.getDirIdRes = res;
        this.$bvModal.show('일괄 폴더이동');
      });
    },
    seqChanged({ added, moved, removed }, key) {
      if (!this.tmpl.tmplId) return;
      if (!this.changedCtrls[key]) this.changedCtrls[key] = Array(this.tmpl[key == 'di' ? 'tmplDocList' : 'tmplRoleList'].length).fill(0).map((n, i) => n + i);
      if (added) this.changedCtrls[key].push(null);
      else if (removed) this.changedCtrls[key].splice(removed.oldIndex, 1);
      else {
        const i = this.changedCtrls[key][moved.oldIndex];
        this.changedCtrls[key].splice(moved.oldIndex, 1);
        this.changedCtrls[key].splice(moved.newIndex, 0, i);
      }
    },
    async save({ statusCd, nextStep }) {
      if (this.editorStep) {
        if (!this.editorScope.ready) return this.$alert(this.$t('문서를 가져오는중입니다.'));

        // 예외처리, 속성 수정 중인 건 저장되도록 하기 위해 실행  
        await this.editorScope.initialCtrl();

        const { tmplId, dirId } = this.tmpl;
        // const formData = this.$json2formdata(this.editorScope.tmpl);
        const formData = this.$json2formdata({});
        formData.append('statusCd', statusCd);
        formData.append('tmplId', tmplId);
        const { users, ctrls } = this.editorScope.tmpl;
        formData.append('jsonCtrls', JSON.stringify(ctrls.map(c => ({ ...c, ui: users[c.ui].i * 1 }))));
        if (dirId) formData.append('dirId', dirId);
        else {
          if(statusCd == 'SAVE') {
            const id = await this.getDirId();
            if (!id) return;
            formData.append('dirId', id);
          }
        }
        let res;
        if(this.$nvl(this.tmpl.pTmplId, 0) == 0) {

          if(statusCd != 'TEMP') { // 임시저장 시엔 유효성 체크 안함
            // 에디터 설계 유효성 검사
            await this.genEditorValidResult(formData);
            
            if(this.editorValidResults.length > 0) {
              const errorCount = this.editorValidResults.filter(result => result.type == 'error').length;
              const warningCount = this.editorValidResults.filter(result => result.type == 'warning').length;
              if(errorCount > 0) {
                if(await this.$alert(this.$t('템플릿 설계가 올바르지 않습니다.<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)'), { size: 'w-350' })) {
                  return;
                }
              } else if(errorCount == 0 && warningCount > 0) {
                if(!await this.$alert(this.$t('경고가 발생했습니다. 그래도 저장하시겠습니까?<br>(왼쪽 상단 <i class="bi bi-bell-fill fs-3 text-danger"></i> 아이콘을 클릭하여 자세한 내용을 확인해 주세요.)'), { confirm: true, okTitle: this.$t('템플릿저장'), size: 'w-350' })) {
                  return;
                }
              }
            }
          }

          res = await this.$api('main/tmpl/insertTmplEditor', formData);
        } else {
          res = await this.$api('main/tmpl/insertTmplEditorSub', formData);
        }

        if (!res.success) {
          return this.$alert(res.msg);
        }
        
        if (nextStep) {
          const mode = this.$route.query.mode;
          const dirId = this.$route.query.dirId;
          this.$router.push(`/tmpl`).then(() => {
            if(mode) {
              // 수정일 경우 기존 선택 된 범주 or 폴더 유지
              this.changeMode({mode, dirId});
            } else {
              // 입력일 경우 선택 된 폴더로 전환
              this.changeMode({mode: 'dir', dirId: formData.get('dirId')});
            }
            this.getList(true);
          });
        }
        return this.$alert(res.msg);
      } else {
        this.editorValidResults = [];
      }

      const data = { ...this.tmpl };
      data.statusCd = statusCd;

      if (!data.tmplNm || !data.tmplNm.trim()) {
        return this.$alert(this.$t('템플릿명 항목을 입력하세요.'));
      } else if (data.tmplDocList.length < 1) {
        return this.$alert(this.$t('문서를 추가하세요.'));
      } else if (data.tmplRoleList.length < 1) {
        return this.$alert(this.$t('참여자를 추가하세요.'));
      } else if (data.tmplRoleList.find(r => !r.roleNm)) {
        return this.$alert(this.$t('역할명을 입력하세요.'));
      }

      for(let i = 0; i < data.tmplRoleList.length; i++) {
        const role = data.tmplRoleList[i];
        if(role.openType == 'LINK') {
          if(role.checkerAddPossYn == 'Y') {
            return this.$alert(this.$t('링크 참여 시 추가 참여자를 등록할 수 없습니다.'));
          } else if(role.partiAddPossYn == 'Y') {
            return this.$alert(this.$t('링크 참여 시 위임자를 추가할 수 없습니다.'));
          }
        }
      }
      
      data.tmplDocList = data.tmplDocList.map(({ docId, docSeq, ver }, i) => ({ sort: i + 1, docId, docSeq, ver }));
      data.tmplRoleList = data.tmplRoleList.map((role, i) => Object.assign({ roleSeq: i + 1 }, role, { sort: i + 1 }));
      data.tmplRoleList.forEach(r => { if (r.openType == 'LOGIN') delete r.authCode });
      if (this.editorTestMode && !(await this.$alert(`<pre>${JSON.stringify(data, null, '  ')}</pre>`, { title: '임시로 전송될 json 확인', confirm: true, size: 'lg' }))) return;
      let jsonCtrls;
      if ((this.changedCtrls.ui || this.changedCtrls.di) && this.tmpl.tmplId) {
        const { data } = await this.$api('main/tmpl/selectTmplEditor', { tmplId: this.tmpl.tmplId });
        if (data && data.jsonCtrls) jsonCtrls = data.jsonCtrls;
      }
      const defaultDetails = { bfExpireNotiDay: 0, securityRating: '5', prodId: '', unconfNotiDay: 0, signValidDay: 30, signMandateYn: 'N' };
      for (const key in defaultDetails) if (data[key] == undefined) data[key] = defaultDetails[key];
      
      const res = await this.$api('main/tmpl/' + (data.tmplId ? (this.$nvl(data.pTmplId, 0) == 0 ? 'updateTmpl' : 'updateTmplSub') : 'insertTmpl'), data);
      if (!res.success) return this.$alert(res.msg);
      if (jsonCtrls) {
        let ctrls = JSON.parse(jsonCtrls);
        if (ctrls.length) {
          if (this.changedCtrls.di) {
            let newCtrls = [];
            this.changedCtrls.di.forEach((oldI, newI) => {
              if (oldI !== null) newCtrls.push(...ctrls.filter(c => c.di == oldI).map(c => ({ ...c, di: newI })));
            });
            ctrls = newCtrls;
          }
          if (ctrls.length && this.changedCtrls.ui) {
            let newCtrls = [];
            this.changedCtrls.ui.forEach((oldI, newI) => {
              if (oldI !== null) newCtrls.push(...ctrls.filter(c => c.ui == oldI).map(c => ({ ...c, ui: newI })));
            });
            ctrls = newCtrls;
          }
          const formData = new FormData();
          formData.append('tmplId', this.tmpl.tmplId);
          formData.append('jsonCtrls', JSON.stringify(ctrls));
          formData.append('statusCd', statusCd);
          if (this.tmpl.dirId) formData.append('dirId', this.tmpl.dirId);
          const res = await this.$api('main/tmpl/' + (this.$nvl(this.tmpl.pTmplId, 0) == 0 ? 'insertTmplEditor' : 'insertTmplEditorSub'), formData);
          if (!res.success) return this.$alert(res.msg);
        }
        this.changedCtrls = {};
      }
      if (res.data && res.data.tmplId) this.tmpl.tmplId = res.data.tmplId;
      if (nextStep && this.tmpl.tmplId) this.editorStep = true;
      else this.$alert(res.msg);
      this.getList(true);
    },
    /** 에디터 설계 유효성 체크 (실제 나올 수 없는 상황은 공통으로 메시지 처리) */
    genEditorValidResult(formData) {
      this.editorValidResults = []; // 에디터 유효성 체크 초기화

      const allCtrls = JSON.parse(formData.get('jsonCtrls'));
      if(allCtrls.length > 0) {
        // 키값 중복 체크
        const keyCtrls = allCtrls.filter(ctrl => this.$isNotEmpty(ctrl.key));
        const checks = [];
        keyCtrls.forEach(ctrl => {
          if(checks.some(check => !['radio', 'check'].includes(ctrl.type) && check.key == ctrl.key) || 
            checks.some(check => ['radio', 'check'].includes(ctrl.type) && check.key == ctrl.key && check.type != ctrl.type)) {
            this.editorValidResults.push({ type: 'warning', message: this.$t('[$] 키값이 중복됩니다.', [ctrl.key]), ctrlId: ctrl.ctrlId });
          }
          checks.push(ctrl);
        });

        // 드롭다운 키값 누락 체크
        const selectCtrls = allCtrls.filter(ctrl => ['select'].includes(ctrl.type));
        selectCtrls.forEach((ctrl, idx) => {
          const targetLabel = this.$nvl(ctrl.key, this.$t('$번째', [idx + 1]));
          if(!ctrl.optionKeys || ctrl.optionKeys.length == 0) {
            this.editorValidResults.push({ type: 'error', message: this.$t('[$] 선택항목이 없습니다.', [targetLabel]), ctrlId: ctrl.ctrlId });
          } else if(ctrl.optionKeys.some(optionKey => this.$isEmpty(optionKey))) {
            this.editorValidResults.push({ type: 'error', message: this.$t('[$] 키값 중 누락된 항목이 있습니다.', [targetLabel]), ctrlId: ctrl.ctrlId });
          } else if(!ctrl.options || ctrl.options.some(option => this.$isEmpty(option))) {
            this.editorValidResults.push({ type: 'error', message: this.$t('[$] 표시값 중 누락된 항목이 있습니다.', [targetLabel]), ctrlId: ctrl.ctrlId });
          } else if(ctrl.optionKeys.length != Array.from(new Set(ctrl.optionKeys.map(optionKey => optionKey))).length) {
            this.editorValidResults.push({ type: 'warning', message: this.$t('[$] 동일한 키가 존재합니다.', [targetLabel]), ctrlId: ctrl.ctrlId });
          }
        });

        // 라디오 버튼, 체크박스 유효성 체크
        const groupCtrls = allCtrls.filter(ctrl => this.$isNotEmpty(ctrl.key) && ['radio', 'check'].includes(ctrl.type));
        const groupKeys = Array.from(new Set(groupCtrls.map(ctrl => ctrl.key)));
        groupKeys.forEach(key => {
          const filterCtrls = groupCtrls.filter(ctrl => ctrl.key == key);
          if(filterCtrls.length > 1) {
            const firstCtrl = filterCtrls[0];
            if(firstCtrl.type == 'check' || firstCtrl.type == 'radio') {
              if(Array.from(new Set(filterCtrls.map(ctrl => ctrl.required))).length != 1) {
                this.editorValidResults.push({ type: 'error', message: this.$t('[$] 필수여부가 다른 항목이 있습니다.', [firstCtrl.key]), ctrlId: firstCtrl.ctrlId });
              }

              const optionVals = [];
              filterCtrls.forEach(ctrl => {
                if(this.$isEmpty(ctrl.optionVal)) {
                  this.editorValidResults.push({ type: 'warning', message: this.$t('[$] 선택값이 없습니다.', [ctrl.key]), ctrlId: ctrl.ctrlId });
                } else if(optionVals.includes(ctrl.optionVal)) {
                  this.editorValidResults.push({ type: 'warning', message: this.$t('[$] 동일한 선택값이 존재합니다.', [ctrl.key]), ctrlId: ctrl.ctrlId });
                }

                optionVals.push(ctrl.optionVal);
              });
            }
          }
        });
      }
    },
    clickEditorValidResult(result) {
      if(this.$refs.editorValid) this.$refs.editorValid.hide(true);
      this.editorScope.tabControl(result.ctrlId);
    },
    async delTmplDoc(idx) {
      this.seqChanged({ removed: { oldIndex: idx } }, 'di');
      // if (!(await this.$alert(this.$t('[$] 문서를 삭제 하시겠습니까?', [this.tmpl.tmplDocList[idx].docNm]), { confirm: true }))) return;
      this.tmpl.tmplDocList.splice(idx, 1);
    },
    async addDoc({ item }) {
      this.seqChanged({ added: {} }, 'di');
      if (this.tmpl.tmplDocList.find(d => d.docId == item.docId)) return this.$alert(this.$t('이미 추가된 문서입니다.'));
      this.$bvModal.hide('첨부추가');
      if (item.pwdExist) {
        this.docPwds = await this.$matchDocPwd([item], true);
      }
      this.tmpl.tmplDocList.push(item);
    },
    async selectAttachDocList(reset) {
      if (reset) this.attachDocList = [];
      this.attachDocParams.firstIndex = this.attachDocList.length + 1;
      this.attachDocList = this.attachDocList.concat((await this.$api('main/tmpl/selectAttachDocList', this.attachDocParams)).list);
    },
    detailSearch({ form }) {
      setTimeout(() => document.activeElement.blur(), 500);
      if (form) this.detail.effectDt = form.effectDt;
      const check = this.detail.effectDt.join('');
      if (!form && !check) return;
      else if (!form) this.detail.effectDt = ['', ''];
      else if (form && !check) return this.$alert(this.$t('발효일이 지정되지 않았습니다.'));
      else if (form && form.effectDt[0] && form.effectDt[1] && form.effectDt[0] > form.effectDt[1]) return this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
      this.listParams.effectDtFrom = this.detail.effectDt[0];
      this.listParams.effectDtTo = this.detail.effectDt[1];
    },
    async selTmpl(crud, tmplKey) {
      if (this.defaultRole.roleNm == undefined) {
        this.defaultRole = { 
          partiNm: undefined, partiEmail: undefined, userId: undefined, memberId: undefined, grpId: undefined, grpNm: undefined,
          roleNm: '', confType: (this.$code('TMPL_CONF_TYPE')[0] || {}).value, taskId: '', 
          openType: this.$code('TMPL_OPEN')[0].value, viewType: this.$code('ENV_VIEW_TYPE')[0].value, partiAddPossYn: 'N', msgUseType: 'VIEW_WRITE', checkerAddPossYn: 'N', atEndRcvCd: 'NOTI_ENVFILE_ATTACH' 
        };
      }

      const tmplId = tmplKey || '';
      if (!tmplId) {
        this.docPwds = null;
        if (crud) {
          this.tmpl = { bfExpireNotiDay: 0, unconfNotiDay: 0, signMandateYn: 'N', coverLetterYn: 'N', tmplRoleList: [{ ...this.defaultRole }], tmplDocList: [] };
        }
      } else if (tmplId) {
        try { // tmplDocList 없는 케이스있음
          let res = {}, times = 0;
          while (times++ < 5 && res.code != 1) {
            if (this.sel && this.sel.pwdExist && !this.docPwds) this.docPwds = await this.$matchDocPwd(this.sel.tmplDocList);
            res = await this.$api('main/tmpl/selectTmpl', { tmplId, docPwds: this.docPwds });
            if (res.code != 1) {
              await this.$alert(res.msg);
              this.docPwds = null;
            }
          }
          if (res.code != 1) throw 'error matchDocPwd';
          this.tmpl = res.data;
          if(this.tmpl.tmplNm) { this.tmpl.tmplNm = this.$unescapeHtml(this.tmpl.tmplNm); } 
          if(this.tmpl.description) { this.tmpl.description = this.$unescapeHtml(this.tmpl.description); } 
        } catch (e) {
          console.log(e);
          return this.$go(-1);
          // return this.$router.replace('/tmpl');
        }
      }
      delete this.tmpl.pwdExist;
      this.changedCtrls = {};
      this.doc = {};
      this.editorStep = false;
    },
    async action({ action, item, form, event }) {
      if (item) this.sel = item;

      if (['휴지통 이동', '영구삭제'].includes(action) && !form) {
        form = { tmplId: (item || this.tmpl).tmplId };
      } else if (action == '수정' && !form) {
        return this.$go(`/tmpl?id=${item.tmplId}&crud=수정`);
      } else if (action == 'e-봉투 만들기') {
        return this.$go('/env?tmplId=' + item.tmplId);
      }

      const { target: el } = event || {};
      if (action == 'view' && el && el.dataset.u == 'favoriteTmpl') {
        if (el.dataset.id) {
          return this.$go('/tmpl?id=' + el.dataset.id);
        }
        const res = await this.$api('main/tmpl/favoriteTmpl', { tmplId: item.tmplId });
        
        // 즐겨찾기 표시 딜레이 방지를 위해 화면에서 강제로 변경 시켜준 후, 실제 결과에 따라 다시 update 하도록 처리
        item.favYn = item.favYn == 'Y' ? 'N' : 'Y';
        if(res.success) {
          document.querySelectorAll('.toast').forEach((toast) => { toast.remove(); });
          this.$toast(res.msg, { variant: res.data == 'Y' ? 'success' : 'danger', toaster: 'b-toaster-bottom-right' });
        } else {
          this.$alert(res.msg);
        }
        
        this.refreshTmpl([item.tmplId]);
        return;
      }
      else if (action.indexOf('일괄 ') == 0) {
        let api, form = {};
        if (action == '일괄 폴더이동') {
          if (!event) {
            this.selFolder = null;
            return this.$bvModal.show(action);
          }
          else if (!this.selFolder) {
            event.preventDefault();
            return this.$alert(this.$t('폴더를 선택하세요.'));
          }
          else if (this.getDirIdRes) return this.getDirId('ok');
          const { dirId } = this.selFolder;
          Object.assign(form, { dirId });
          api = 'moveTmplToDir';
          if (this.crud == '추가') action = '저장';
        }
        else {
          window.tmp = v => form.statusReason = v;
          if (!(await this.$alert(`${this.$t('해당 항목을 $ 처리하시겠습니까?', [action])}<div class="alert_list"><ul><li>${this.sel.map(i => i.tmplNm).join('</li><li>')}</li></ul></div>
          <textarea maxlength="1000" style="width:100%" onchange="tmp(this.value)" placeholder="${this.$t('비고')}"></textarea>`, { okVariant: action.indexOf('취소') > 0 ? 'danger' : 'success', okTitle: action.slice(3), title: action, confirm: true }))) return;
          api = action == '일괄 등록완료' ? 'approveTmpl' : 'cancelTmpl';
        }
        form.tmplIds = this.sel.map(t => t.tmplId);
        const { list } = await this.$api('main/tmpl/' + api, form);
        let successList = list.filter(result => result.result == true);
        let failList = list.filter(result => result.result == false);

        let resultContent = `
          <div class="alert_list">
            ${successList.length > 0 ? `
              <div class="text-success text-bolder mb-1">${this.$t('성공')}</div>
              <ul>${successList.map(result => `<li>${result.resultMessage}</li>`).join('')}</ul>
            ` : ``}
            ${failList.length > 0 ? `
              <div class="text-danger text-bolder mb-1">${this.$t('실패')}</div>
              <ul>${failList.map(result => `<li>${result.resultMessage}</li>`).join('')}</ul>
            ` : ``}
          </div>
        `;

        if (successList.length > 0) {
          this.refreshTmpl(form.tmplIds);

          if (this.tmpl && form.dirId) {
            this.tmpl.dirId = form.dirId;
            this.$go('/tmpl?id=' + this.tmpl.tmplId);
          } else  if(api == 'moveTmplToDir') {
            if(form.dirId) {
              await this.changeMode({mode: 'dir', dirId: form.dirId});
              await this.getList(true);
            } else {
              await this.getList(true);
            }
          }
        }
        await this.$alert(resultContent, { size: 'w-400' });
        return;
      } else if (form) {
        if (['휴지통 이동', '영구삭제'].includes(action) && !(await this.$alert(this.$t('[$] 템플릿을 [$] 하시겠습니까?', [(item || this.tmpl).tmplNm, action]), { confirm: true }))) {
          return;
        }

        let res;
        if (action == '내 템플릿 만들기' || action == '복사') {
          form.dirId = await this.getDirId(null, true);
          if (!form.dirId) return;
          form.tgtTmplId = this.sel.tmplId;
          form.mode = action == '내 템플릿 만들기' ? 'MY_TMPL' : 'COPY';
          res = await this.$api('main/tmpl/insertTmplSub', form);
        } else {
          res = await this.$api('main/tmpl/' + ({
            '휴지통 이동': (this.tmpl && this.tmpl.pTmplId == 0 ? 'moveTmplTrash' : 'moveTmplTrashSub'),
            '영구삭제': (this.tmpl && this.tmpl.pTmplId == 0 ? 'deleteTmpl' : 'deleteTmplSub'),
            '추가': 'insertTmpl',
            '수정': (this.tmpl && this.tmpl.pTmplId == 0 ? 'updateTmpl' : 'updateTmplSub')
          })[action], form);
        }
        
        await this.$alert(res.msg);
        if (res.success) {
          if (this.tmpl) {
            // 상세 화면에서 수행
            if(['휴지통 이동', '영구삭제'].includes(action)) {
              this.tmpl = null;
              this.$router.push(`/tmpl`).then(() => {
                this.changeMode({mode: this.listParams.mode, dirId: this.listParams.dirId});
                this.getList(true);
              });
              return;
            } else {
              this.$go(-1);
              this.getList(true);
              return;
            }
          } else if(form.dirId) {
            await this.changeMode({mode: 'dir', dirId: form.dirId});
            await this.getList(true);
            return;
          }
        }

        return;
      } else if (action == 'view') {
        return this.$go('tmpl?id=' + this.sel.tmplId);
      }

      this.$bvModal.show(action);
    },
    async getList(reset) {
      if (reset === true) this.list = [];
      const { list, parameter: { total } } = await this.$api('main/tmpl/selectTmplList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.serverTotal = total;
      if (reset === true) {
        this.list = [...list];
      } else {
        this.list.push(...list);
      }

      if(this.listParams.dirId) {
        const dirItem = this.tmplDirList.find(dir => dir.dirId === this.listParams.dirId);
        this.subTitle = dirItem ? dirItem.dirNm : '';
      } else {
        const menuItem = this.tmplMenus.find(menu => menu.key === this.listParams.mode);
        this.subTitle = menuItem ? menuItem.label : '';
      }
    },
    async refreshTmpl(tmplIds) {
      this.keepPage = true;
      for(let tmplId of tmplIds) {
        const selTmpl = await this.$api('main/tmpl/selectTmplOne', { tmplId: tmplId });
        this.$set(this.list, this.list.findIndex(item => item.tmplId === tmplId), selTmpl.data);
      }
      this.$nextTick(()=> { this.keepPage = false; });
    }
  },
}
</script>